import axios from 'axios';
import config from 'config.js';

// Constants
const GET_CHANGELOG_REQUEST = 'changelog/GET_CHANGELOG_REQUEST';
const GET_CHANGELOG_SUCCESS = 'changelog/GET_CHANGELOG_SUCCESS';
const GET_CHANGELOG_FAILURE = 'changelog/GET_CHANGELOG_FAILURE';

const CREATE_CHANGE_REQUEST = 'changelog/CREATE_CHANGE_REQUEST';
const CREATE_CHANGE_SUCCESS = 'changelog/CREATE_CHANGE_SUCCESS';
const CREATE_CHANGE_FAILURE = 'changelog/CREATE_CHANGE_FAILURE';

const REMOVE_CHANGE_REQUEST = 'changelog/REMOVE_CHANGE_REQUEST';
const REMOVE_CHANGE_SUCCESS = 'changelog/REMOVE_CHANGE_SUCCESS';
const REMOVE_CHANGE_FAILURE = 'changelog/REMOVE_CHANGE_FAILURE';

const PUBLISH_CHANGE_REQUEST = 'changelog/PUBLISH_CHANGE_REQUEST';
const PUBLISH_CHANGE_SUCCESS = 'changelog/PUBLISH_CHANGE_SUCCESS';
const PUBLISH_CHANGE_FAILURE = 'changelog/PUBLISH_CHANGE_FAILURE';

const getEndpointStatus = (type) => {
  const types = {
    request: {
      loading: true,
      error: false,
      success: false
    },
    success: {
      loading: false,
      error: false,
      success: true
    },
    failure: {
      loading: false,
      error: true,
      success: false
    },
  };

  return types[type];
};

const endpoitInitialStatus = {
  loading: false,
  error: false,
  success: false
};

// Initiual State
const initialState = {
  changelog: null,

  getChangelog: { ...endpoitInitialStatus },
  createChange: { ...endpoitInitialStatus },
  removeChange: { ...endpoitInitialStatus },
  removeChange: { ...endpoitInitialStatus }
};

// Reducer
export default function reducer(state = JSON.parse(JSON.stringify(initialState)), action = {}) {
  // getChangelog
  if (action.type === GET_CHANGELOG_REQUEST) {
    state.getChangelog = getEndpointStatus('request');

    return { ...state };
  }

  if (action.type === GET_CHANGELOG_SUCCESS) {
    state.getChangelog = getEndpointStatus('success');
    state.changelog = action.payload;

    return { ...state };
  }

  if (action.type === GET_CHANGELOG_FAILURE) {
    state.getChangelog = getEndpointStatus('failure');

    return { ...state };
  }

  // createChange
  if (action.type === CREATE_CHANGE_REQUEST) {
    state.createChange = getEndpointStatus('request');

    return { ...state };
  }

  if (action.type === CREATE_CHANGE_SUCCESS) {
    state.createChange = getEndpointStatus('success');

    return { ...state };
  }

  if (action.type === CREATE_CHANGE_FAILURE) {
    state.createChange = getEndpointStatus('failure');

    return { ...state };
  }

  // removeChange
  if (action.type === REMOVE_CHANGE_REQUEST) {
    state.removeChange = getEndpointStatus('request');

    return { ...state };
  }

  if (action.type === REMOVE_CHANGE_SUCCESS) {
    state.removeChange = getEndpointStatus('success');

    return { ...state };
  }

  if (action.type === REMOVE_CHANGE_FAILURE) {
    state.removeChange = getEndpointStatus('failure');

    return { ...state };
  }

  return state;
}

// Action Creators
export function getChangelog() {
  const request = () => { return { type: GET_CHANGELOG_REQUEST } };
  const success = (res) => { return { type: GET_CHANGELOG_SUCCESS, payload: res } };
  const failure = () => { return { type: GET_CHANGELOG_FAILURE } };

  return async (dispatch) => {
    dispatch(request());

    const response = await services.getChangelog();

    if (response && response.status === 200) {
      return dispatch(success(response.data));
    } else {
      return dispatch(failure());
    }
  };
}

export function createChange(data) {
  const request = () => { return { type: CREATE_CHANGE_REQUEST } };
  const success = (res) => { return { type: CREATE_CHANGE_SUCCESS, payload: res } };
  const failure = () => { return { type: CREATE_CHANGE_FAILURE } };

  return async (dispatch) => {
    dispatch(request());

    const response = await services.createChange(data);

    if (response) {
      return dispatch(success(response));
    } else {
      return dispatch(failure());
    }
  };
}

export function removeChange(id) {
  const request = () => { return { type: REMOVE_CHANGE_REQUEST } };
  const success = () => { return { type: REMOVE_CHANGE_SUCCESS } };
  const failure = () => { return { type: REMOVE_CHANGE_FAILURE } };

  return async (dispatch) => {
    dispatch(request());

    const response = await services.removeChange(id);

    if (response) {
      return dispatch(success(response));
    } else {
      return dispatch(failure());
    }
  };
}

export function publishChange(id) {
  const request = () => { return { type: PUBLISH_CHANGE_REQUEST } };
  const success = () => { return { type: PUBLISH_CHANGE_SUCCESS } };
  const failure = () => { return { type: PUBLISH_CHANGE_FAILURE } };

  return async (dispatch) => {
    dispatch(request());

    const response = await services.publishChange(id);

    if (response) {
      return dispatch(success(response));
    } else {
      return dispatch(failure());
    }
  };
}


const services = {
  getChangelog: async () => {
    try {
      const response = await axios({
        method: 'GET',
        url: `${config.apiUrl}/api/admin/changelog`,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('user_token')}`
        }
      });

      return response;
    } catch (e) {
      return e.response;
    }
  },
  createChange: async (data) => {
    try {
      const response = await axios({
        method: 'POST',
        url: `${config.apiUrl}/api/admin/changelog`,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('user_token')}`
        },
        data
      });

      return response.data;
    } catch (e) {
      return false;
    }
  },
  removeChange: async (id) => {
    try {
      const response = await axios({
        method: 'DELETE',
        url: `${config.apiUrl}/api/admin/changelog/${id}`,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('user_token')}`
        }
      });

      return response.data;
    } catch (e) {
      return false;
    }
  },
  publishChange: async (id) => {
    try {
      const response = await axios({
        method: 'PUT',
        url: `${config.apiUrl}/api/admin/changelog/${id}`,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('user_token')}`
        }
      });

      return response.data;
    } catch (e) {
      return false;
    }
  }
};
